module.exports = __webpack_public_path__ + "static/media/title-mobile.e439933d.png";